module.exports = __webpack_public_path__ + "img/bottom_bg.fdc56ef.png";